<div class="line-contents">
  <div
    class="line-cell line-period"
    [class.line-cell-aggregation]="isAggregationRow()"
  >
    {{ getPeriod() }}
  </div>
  <div class="line-rows">
    @for (marketplace of marketplaces; track $index) {
      <div class="line-content">
        <div
          class="line-marketplace line-cell"
          [class.line-cell-aggregation]="isAggregationRow()"
        >
          {{ marketplace.value }}
        </div>
        <app-daily-feedback-reports-rating
          [isAggregationRow]="isAggregationRow()"
          [type]="'Published'"
          [marketplace]="marketplace.id"
          [data]="data()"
        />
        <div
          class="line-cell line-count"
          [class.line-cell-aggregation]="isAggregationRow()"
        >
          {{ getQuantity('Published', marketplace.id) }}
        </div>
      </div>
    }
  </div>
  <div
    class="line-cell line-count"
    [class.line-cell-aggregation]="isAggregationRow()"
  >
    {{ getTotal('totalPublishedMark') }}
  </div>
  <div class="line-rows">
    @for (marketplace of marketplaces; track $index) {
      <div class="line-content">
        <app-daily-feedback-reports-rating
          [isAggregationRow]="isAggregationRow()"
          [type]="'Removed'"
          [marketplace]="marketplace.id"
          [data]="data()"
        />
        <div
          class="line-cell line-count"
          [class.line-cell-aggregation]="isAggregationRow()"
        >
          {{ getQuantity('Removed', marketplace.id) }}
        </div>
      </div>
    }
  </div>
  <div
    class="line-cell line-count"
    [class.line-cell-aggregation]="isAggregationRow()"
  >
    {{ getTotal('totalRemovedMark') }}
  </div>
  <div class="line-rows">
    @for (marketplace of marketplaces; track $index) {
      <div class="line-content">
        <div class="line-min-rows">
          @for (item of negativePercentValueType; track $index) {
            <div
              class="line-cell line-negative"
              [class.line-cell-aggregation]="isAggregationRow()"
            >
              {{ getNegativePercent(marketplace.id, item) }}
            </div>
          }
        </div>
        <div
          class="line-cell line-count line-negative"
          [class.line-cell-aggregation]="isAggregationRow()"
        >
          {{ getNegativePercent(marketplace.id, 'total') }}
        </div>
      </div>
    }
  </div>
  <div
    class="line-cell line-count line-total-negative"
    [class.line-is-negative]="getIsTotalNegativePercentMismatch()"
  >
    {{ getTotal('totalNegativePercent') }}
  </div>
</div>
